import utils = egr.wcf.utils;
import { ProjectProperties, ProjectAttributes } from '../actions/ProjectManagerActions';
import { UIHelper } from './UIHelper';
import { PconLoginStore } from '../stores/PconLoginStore';

export enum ProjectLoadMethod {
    // The values of the existing entries must not be changed!!!
    OBK = 0,
    CONTAINER = 1
}

export class ProjectInstance {

    public get id(): string {
        return this.pId != null ? this.pId : this.pTmpId;
    }

    public get name(): string | undefined {
        return this.pName == null ? this.properties.name : this.pName;
    }

    public set name(value: string | undefined) {
        this.pName = value;
    }

    public get image(): string | undefined {
        return this.pImage == null ? this.properties.image : this.pImage;
    }

    public set image(value: string | undefined) {
        this.pImage = value;
    }

    public get mtime(): number {
        return this.properties.mtime;
    }

    public get attributes(): ProjectAttributes | undefined {
        return this.properties.attributes;
    }

    public get isNew(): boolean {
        return this.pId == null;
    }

    public get loadMethod(): ProjectLoadMethod {
        return this.pLoadMethod == null ? this.properties.loadMethod : this.pLoadMethod;
    }

    public set loadMethod(value: ProjectLoadMethod) {
        this.pLoadMethod = value;
    }

    public static getTimeStamp(): number {
        return Math.floor(Date.now() / 1000);
    }
    public readonly date: Date;

    protected properties: ProjectProperties;

    private pId: string | null;
    private pTmpId: string;
    private pName: string | undefined;
    private pImage: string | undefined;
    private pLoadMethod: ProjectLoadMethod | null = null;

    constructor(projectId: string | null, value?: string | ProjectProperties) {
        if (utils.string.isNullOrEmpty(projectId)) {
            this.pTmpId = UIHelper.getUUID();
        } else {
            this.pId = projectId;
        }

        if (utils.string.isNullOrEmpty(value as string)) {
            const time: number = ProjectInstance.getTimeStamp();

            this.properties = {
                mtime: time,
                crtime: time,
                attributes: PconLoginStore.getIdentifier(),
                loadMethod: ProjectLoadMethod.CONTAINER
            };
        } else if (utils.string.isString(value)) {
            this.properties = JSON.parse(value as string) as ProjectProperties;
        } else {
            this.properties = jQuery.extend({}, value) as ProjectProperties;
        }

        this.date = new Date(this.properties.mtime * 1000);
    }

    public toJson(updateTime: boolean = true): string {
        const newProperties: ProjectProperties = jQuery.extend(
            {},
            this.properties,
            this.pName != null ? {name: this.pName} : {},
            this.pImage != null ? {image: this.pImage} : {},
            this.pLoadMethod != null ? {loadMethod: this.pLoadMethod} : {},
            updateTime === true ? {mtime: ProjectInstance.getTimeStamp()} : {}
        ) as ProjectProperties;

        return JSON.stringify(newProperties);
    }

    // Internal (AppProjectManager) use only!!!
    public _wasSaved(): void {
        if (this.pId == null) {
            this.pId = this.pTmpId;
            // this.pTmpId = undefined;
        }
    }

    public _wasNotSaved(): void {
        if (this.pId != null) {
            this.pTmpId = this.pId;
            this.pId = null;
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/ProjectInstance.ts